import { Module } from 'vuex';
import { AxiosResponse } from 'axios';
import {
  SET_ACCOUNT,
  SET_SESSION_TOKEN,
  SET_ERRORMSG,
} from '@/store/mutation_types';
import {
  LOGIN,
  SIGNUP,
  UPDATE_ACCOUNT,
  GET_AUTH_ACCOUNT,
  VERIFY_EMAIL,
  CLEAR_ACCOUNT_ISLOADING,
  LOGOUT,
  RESET_PASSWORD_AUTHED,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  REQUEST_EMAIL_VERIFICATION,
  SET_PASSWORD_AND_VERIFY,
  REQUEST_SET_PASSWORD_AND_VERIFY,
  SIGNUP_OAUTH,
  LOGIN_OAUTH,
  END_SUPPORT_SESSION,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import { LoginCredentals, LoginOAuthCredentals, SignupCredentals, SignupOAuthCredentals } from '@/dtos/auth.dto';
import { LOCAL_STORAGE_KEY, TOAST_GLOBAL_CONFIG } from '@/utils/const';
import {
  EditUser,
  ForgotPassword,
  GetUser,
  ResetPassword,
  ResetPasswordObj,
  SetPasswordPasswordAndVerifyObj,
} from '@/dtos/user.dto';
import Auth from '@/services/auth';
import User from '@/services/user';
import { UserRoles } from '@/utils/enums';

const account: Module<any, {}> = {
  state: {
    account: {
      data: null,
      status: null,
      isLoading: false,
    },
    sessionToken: null,
  },
  getters: {
    account: (state: { account: any }) => state.account,
    sessionToken: (state: { sessionToken: any }) => state.sessionToken,
  },
  mutations: {
    [SET_ACCOUNT]: (
      state: { account: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.account.data = payload.data) : null,
        (state.account.status = payload.status),
        (state.account.isLoading = payload.isLoading);
    },
    [SET_SESSION_TOKEN]: (state: { sessionToken: any }, payload: any) => {
      state.sessionToken = payload;
    },
  },
  actions: {
    [LOGIN]: async ({ commit }: any, payload: any) => {
      commit(SET_ACCOUNT, { data: null, isLoading: true });

      const result: AxiosResponse = await Auth.login(
        payload as LoginCredentals
      );

      if (result) {
        if (result.data.status) {
          if(result.data.data.role != UserRoles.superAdmin) {
            commit(SET_ACCOUNT, { data: null, isLoading: false });
            return { error: 'You dont have the required role.' };
          }
          commit(SET_SESSION_TOKEN, result.data.sessionToken);
          commit(SET_ACCOUNT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ACCOUNT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ACCOUNT, { isLoading: false });
        return false;
      }
    },
    [LOGIN_OAUTH]: async ({ commit }: any, payload: any) => {
      commit(SET_ACCOUNT, { data: null, isLoading: true });

      const result: AxiosResponse = await Auth.loginOAuth(
        payload as LoginOAuthCredentals
      );

      if (result) {
        if (result.data.status) {
          if(result.data.data.role != UserRoles.superAdmin) {
            commit(SET_ACCOUNT, { data: null, isLoading: false });
            return { error: 'You dont have the required role.' };
          }
          commit(SET_SESSION_TOKEN, result.data.sessionToken);
          commit(SET_ACCOUNT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ACCOUNT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ACCOUNT, { isLoading: false });
        return false;
      }
    },
    [SIGNUP]: async ({ commit }: any, payload: any) => {
      commit(SET_ACCOUNT, { data: null, isLoading: true });

      const result: AxiosResponse = await Auth.signup(
        payload as SignupCredentals
      );

      if (result) {
        if (result.data.status) {
          commit(SET_SESSION_TOKEN, result.data.sessionToken);
          commit(SET_ACCOUNT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ACCOUNT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ACCOUNT, { isLoading: false });
        return false;
      }
    },
    [SIGNUP_OAUTH]: async ({ commit }: any, payload: any) => {
      console.log('payload', payload)
      commit(SET_ACCOUNT, { data: null, isLoading: true });

      const result: AxiosResponse = await Auth.signupOAuth(
        payload as SignupOAuthCredentals
      );

      if (result) {
        if (result.data.status) {
          commit(SET_SESSION_TOKEN, result.data.sessionToken);
          commit(SET_ACCOUNT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ACCOUNT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ACCOUNT, { isLoading: false });
        return false;
      }
    },
    [UPDATE_ACCOUNT]: async ({ commit }: any, payload: any) => {
      commit(SET_ACCOUNT, { isLoading: true });

      const result: AxiosResponse = await Auth.updateAccount(
        payload as EditUser
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ACCOUNT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ACCOUNT, { isLoading: false });
        return false;
      }
    },
    [FORGOT_PASSWORD]: async ({ commit }: any, payload: any) => {
      commit(SET_ACCOUNT, { isLoading: true });

      const result: AxiosResponse = await Auth.forgotPassword(
        payload as ForgotPassword
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ACCOUNT, { isLoading: false });
          return true;
        }
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ACCOUNT, { isLoading: false });
        return false;
      }
    },
    [RESET_PASSWORD]: async ({ commit }: any, payload: any) => {
      commit(SET_ACCOUNT, { isLoading: true });

      const result: AxiosResponse = await Auth.resetPassword(
        payload as ResetPasswordObj
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ACCOUNT, { isLoading: false });
          return true;
        }
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ACCOUNT, { isLoading: false });
        return false;
      }
    },
    [RESET_PASSWORD_AUTHED]: async ({ commit }: any, payload: any) => {
      commit(SET_ACCOUNT, { isLoading: true });

      const result: AxiosResponse = await Auth.resetPasswordAuthed(
        payload as ResetPassword
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ACCOUNT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ACCOUNT, { isLoading: false });
        return false;
      }
    },
    [REQUEST_SET_PASSWORD_AND_VERIFY]: async (
      { commit }: any,
      payload: any
    ) => {
      commit(SET_ACCOUNT, { isLoading: true });

      const result: AxiosResponse = await Auth.requestSetPasswordAndVerify(
        payload as GetUser
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ACCOUNT, { isLoading: false });
          return result.data.data;
        }
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ACCOUNT, { isLoading: false });
        return false;
      }
    },
    [SET_PASSWORD_AND_VERIFY]: async ({ commit }: any, payload: any) => {
      commit(SET_ACCOUNT, { isLoading: true });

      const result: AxiosResponse = await Auth.setPasswordAndVerify(
        payload as SetPasswordPasswordAndVerifyObj
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ACCOUNT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ACCOUNT, { isLoading: false });
        return false;
      }
    },
    [REQUEST_EMAIL_VERIFICATION]: async (
      { commit, state }: any,
      payload: any
    ) => {
      commit(SET_ACCOUNT, { isLoading: true });

      const result: AxiosResponse = await Auth.requestEmailVerification(
        payload as GetUser
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ACCOUNT, { isLoading: false });
          return true;
        }
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ACCOUNT, { isLoading: false });
        return false;
      }
    },
    [VERIFY_EMAIL]: async ({ commit, state }: any, payload: any) => {
      commit(SET_ACCOUNT, { isLoading: true });

      const result: AxiosResponse = await Auth.verifyEmail(payload as string);

      if (result) {
        if (result.data.status) {
          // Create a copy of the account object and update the isVerified field
          let account = { ...state.account.data, isEmailVerified: true };

          commit(SET_ACCOUNT, { data: account, isLoading: false });
          return true;
        }
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ACCOUNT, { isLoading: false });
        return false;
      }
    },
    [GET_AUTH_ACCOUNT]: async ({ commit, state }: any) => {
      commit(SET_ACCOUNT, { isLoading: true });

      const result: AxiosResponse = await User.getUsers({
        id: state.account.data.id,
      } as GetUser);

      if (result) {
        if (result.data.status) {
          commit(SET_ACCOUNT, { data: result.data.data[0], isLoading: false });
          return result.data.data[0];
        }
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ACCOUNT, { isLoading: false });
        return false;
      }
    },
    // `recordSignOut` when the person chose to sign out: the API is told first,
    // while the session still works, so the activity log can say so. A sign-out
    // forced by an expired or refused session is not reported.
    [LOGOUT]: async ({ commit, state, dispatch }, options?: { recordSignOut?: boolean }) => {
      // A support session open in its desktop ends with the sign-out, while
      // the admin's own token still works. Sent outside the API's handlers,
      // so a sign-out forced by a refused session can't loop back here.
      await dispatch(END_SUPPORT_SESSION, { reason: 'signed_out' });
      if (options?.recordSignOut && state.sessionToken) {
        await Auth.recordSignOut(state.sessionToken);
      }
      commit(SET_SESSION_TOKEN, null);
      commit(SET_ACCOUNT, { data: null, isLoading: false });
      localStorage.removeItem(LOCAL_STORAGE_KEY);
      return true;
    },
    [CLEAR_ACCOUNT_ISLOADING]: ({ commit }) => {
      commit(SET_ACCOUNT, { isLoading: false });
    },
  },
};

export default account;
